import React, { useEffect, useState, useContext } from "react";
import {
  getSuppliers,
  deleteSupplier,
  updateSupplier,
  createSupplier,
} from "../../../Utility/Api";
import { toast } from "react-toastify";
import "../../../Utility/pagination.css";
import SupplierForm from "./form";
import { Deletemodel, Pagination } from "../../Common/Functions";
import { CommonCardUi, InputField, TextArea } from "../../Common/CommonCard";
import { WarehouseContext } from "../../../Utility/UserContext";
import { isReadonlyRoute, NaviGate, getStoredEntriesPerPage } from "../../../Utility/function";
import { useLocation } from "react-router-dom";

const Supplier_list = () => {
  const { pathname } = useLocation();
  const readonly = isReadonlyRoute(pathname);
  const [suppliers, setSuppliers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedSupplier, setselectedSupplier] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [entriesPerPage, setEntriesPerPage] = useState(getStoredEntriesPerPage(10));
  const [deleteID, setDeleteID] = useState("");
  const [deletemodel, showDeletemodel] = useState(false);
  const { showLoader, hideLoader, shopItem, UserItem } =
    useContext(WarehouseContext);


  const [user, setUser] = useState(UserItem);
  const [cardShow, setCardShow] = useState(0);
  const [formData, setFormData] = useState({
    full_name: "",
    address1: "",
    address2: "",
    address3: "",
    email: "",
    phone: "",
    postal_code: "",
    opening_balance: "",
    CR_DR: "0",
    VAT_no: "",
    created_by: user.user_id,
    remarks: "",
    shop_id: shopItem?.shop_id || "0",
    created_by: UserItem?.user_id || "0",
  });

  const [BankData, setBankData] = useState({
    supplier_id: "",
    account_name: "",
    account_no: "",
    bank: "",
    branch: "",
    ifsc_swift_code: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchSuppliers(currentPage, "", entriesPerPage);
  }, []);

  const handledeletemodel = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  };

  const fetchSuppliers = async (page = currentPage, text = "", limit = entriesPerPage) => {
    showLoader()
    try {
      const response = await getSuppliers(page, text, limit);
      if (response.data && response.data.data) {
        setSuppliers(response.data.data);
        const calcPages = response.data.pagination?.total_pages || Math.max(1, Math.ceil((response.data.pagination?.total_records || response.data.data.length) / limit));
        setTotalPages(calcPages);
        hideLoader()
      }
    } catch (error) {
      console.error("Error fetching suppliers data:", error);
      toast.error("Error fetching suppliers");
      hideLoader()
    }
  };

  const openModal = (supplier = null) => {
    console.log('supplier value check', supplier);
    setselectedSupplier(supplier);
    setCardShow(1);
    setFormData({
      created_by: user.user_id,
      full_name: supplier.full_name,
      address1: supplier.address1,
      address2: supplier.address2,
      address3: supplier.address3,
      email: supplier.email,
      phone: supplier.phone,
      postal_code: supplier.postal_code,
      VAT_no: supplier.VAT_no,
      opening_balance: supplier.opening_balance || "",
      remarks: supplier.remarks,
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
    });
    setBankData({
      account_name: supplier.account_name,
      account_no: supplier.account_no,
      bank: supplier.bank,
      branch: supplier.branch,
      ifsc_swift_code: supplier.ifsc_swift_code,
      supplier_id: supplier.supplier_id,
    });
    setEditButton(true);
    // setShowModal(true);
  };

  const handleDelete = async () => {
    try {
      await deleteSupplier(deleteID);
      showDeletemodel(false);
      toast.error("Supplier is Inactivated");
      await fetchSuppliers(currentPage);

    } catch (error) {
      console.error("Error deleting supplier:", error);
      toast.error("Error deleting supplier");
    }
  };

  const handleUndoDelete = async (id) => {
    try {
      await deleteSupplier(id);
      toast.success("Supplier is Activated");
      fetchSuppliers(currentPage);
    } catch (error) {
      console.error("Error Activating supplier:", error);
      toast.error("Error Activating supplier");
    }
  };

  const handlePageChange = (pageNumber) => {
    if (pageNumber < 1 || pageNumber > totalPages) return;
    setCurrentPage(pageNumber);
    fetchSuppliers(pageNumber, "", entriesPerPage);
  };

  const handleSearch = async (text) => {
    fetchSuppliers(1, text, entriesPerPage);
    setCurrentPage(1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "opening_balance") {
      if (value !== "" && parseFloat(value) < 0) {
        return;
      }
    }
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setFormData({
        ...formData,
        [name]: numericValue,

      });
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
      return;
    }
    if (name === "email") {
      const emailPattern =
        /^[a-zA-Z0-9._%+-]+@(gmail\.com|yopmail\.com|yahoo\.com)$/;
      const emailErrorElement = document.getElementById("emailError");

      //   if (!emailPattern.test(value)) {
      //     emailErrorElement.style.display = "block"; // Show error message
      //   } else {
      //     emailErrorElement.style.display = "none"; // Hide error message
      //   }
    }
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;
    if (name === "phone") {
      const numericValue = value.replace(/[^0-9]/g, ""); // Remove non-numeric characters
      setBankData({
        ...formData,
        [name]: numericValue,
      });
      return;
    }
    if (name === "email") {
      const emailPattern =
        /^[a-zA-Z0-9._%+-]+@(gmail\.com|yopmail\.com|yahoo\.com)$/;
      const emailErrorElement = document.getElementById("emailError");

      if (!emailPattern.test(value)) {
        emailErrorElement.style.display = "block"; // Show error message
      } else {
        emailErrorElement.style.display = "none"; // Hide error message
      }
    }
    setBankData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  const handleSubmit = async (e, addoredit) => {
    console.log(addoredit);
    showLoader();
    const validationErrors = {};

    for (const key in formData) {
      // if (key !== "remarks" && key != "CR_DR" && key != "opening_balance" && !formData[key]) {
      if (key === "full_name" || key === "phone") {
        if (!formData[key]) {
          validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
        } else if (key === "phone" && formData[key].length < 8) {
          validationErrors[key] = "Phone number must be at least 8 digits long.";
        }
      }
    }
    // for (const key in BankData) {
    //   if (key === "supplier_id") {
    //     continue;
    //   }
    //   if (!BankData[key]) {
    //     validationErrors[key] = `${key.replace(/_/g, " ")} is required.`;
    //   }
    // }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      hideLoader();
      console.log(validationErrors);
      return;
    }

    const payload = {
      supplier: formData,
      bank: BankData,
    };

    try {
      if (addoredit == 1) {
        await updateSupplier(selectedSupplier.supplier_id, payload);
        hideLoader();
        toast.success("Supplier updated successfully");
        setCardShow(0);
      } else {
        await createSupplier(payload);
        hideLoader();
        toast.success("Supplier added successfully");
        setCardShow(0);
      }
      setErrors({});
      handleclear();
      fetchSuppliers(currentPage);
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Unknown error";
      console.error("Error saving supplier data:", errorMsg);
      hideLoader();
      toast.error(errorMsg);
    }
  };
  const [EditButton, setEditButton] = useState(false);
  const handleclear = () => {
    setFormData({
      full_name: "",
      address1: "",
      address2: "",
      address3: "",
      email: "",
      phone: "",
      postal_code: "",
      opening_balance: "",
      VAT_no: "",
      created_by: user.user_id,
      remarks: "",
      shop_id: shopItem?.shop_id || "0",
      created_by: UserItem?.user_id || "0",
    });
    setBankData({
      supplier_id: "",
      account_name: "",
      account_no: "",
      bank: "",
      branch: "",
      ifsc_swift_code: "",
    });
    setEditButton(false);
    setErrors({});
  };

  const feilds = (
    <>
      <div className="col-6">
        {InputField(
          "Suppliers",
          "full_name",
          "text",
          formData.full_name,
          handleChange,
          "Enter Name",
          12,
          null,
          errors.full_name
        )}
        {/* OLD CODE:
        {InputField(
          "Address 1",
          "address1",
          "text",
          formData.address1,
          handleChange,
          "Enter Address 1",
          12,
          null,
          errors.address1
        )}
        */}
        {InputField(
          "Address",
          "address1",
          "text",
          formData.address1,
          handleChange,
          "Enter Address",
          12,
          null,
          errors.address1
        )}
        {/* OLD CODE:
        {InputField(
          "Address 2",
          "address2",
          "text",
          formData.address2,
          handleChange,
          "Enter Address 2",
          12,
          null,
          errors.address2
        )}
        */}
        {/* OLD CODE:
        {InputField(
          "Address 3",
          "address3",
          "text",
          formData.address3,
          handleChange,
          "Enter Address 3",
          12,
          null,
          errors.address3
        )}
        */}
        {InputField(
          "Email",
          "email",
          "text",
          formData.email,
          handleChange,
          "Enter Email",
          12,
          null,
          errors.email
        )}
        <div className="d-flex column-gap-1 d-none">
          {InputField(
            "Balance",
            "opening_balance",
            "text",
            formData.opening_balance,
            handleChange,
            "Enter Balance",
            8,
            null,
            errors.opening_balance
          )}
          <div className="col-4">
            <select
              name="CR_DR"
              value={formData.CR_DR}
              onChange={handleChange}
              className=""
              style={{
                height: "1.5rem",
                margin: "1px",
                fontSize: "0.7rem",
              }}
            >
              <option value="">Select CR DR</option>
              <option key="0" value="0">
                CR
              </option>
              <option key="1" value="1">
                DR
              </option>
            </select>
          </div>
        </div>
        {TextArea(
          "Remarks",
          "remarks",
          "text",
          formData.remarks,
          handleChange,
          "Enter your remark",
          12,
          true
        )}
      </div>
      <div className="col-6">
        {InputField(
          "Phone",
          "phone",
          "text",
          formData.phone,
          handleChange,
          "Enter Phone Number",
          12,
          null,
          errors.phone
        )}
        {InputField(
          "GST No",
          "VAT_no",
          "text",
          formData.VAT_no,
          handleChange,
          "Enter GST ",
          12,
          null,
          errors.VAT_no
        )}
        {/* OLD CODE:
        {InputField(
          "Postal Code",
          "postal_code",
          "text",
          formData.postal_code,
          handleChange,
          "Enter Postal code",
          12,
          null,
          errors.postal_code
        )}
        */}
        {InputField(
          "Account Name",
          "account_name",
          "text",
          BankData.account_name,
          handleBankChange,
          "Enter Account Name",
          12,
          null,
          errors.account_name
        )}
        {InputField(
          "Account no",
          "account_no",
          "text",
          BankData.account_no,
          handleBankChange,
          "Enter Account No",
          12,
          null,
          errors.account_no
        )}
        {InputField(
          "Bank",
          "bank",
          "text",
          BankData.bank,
          handleBankChange,
          "Enter Bank",
          12,
          null,
          errors.bank
        )}
        {InputField(
          "Branch",
          "branch",
          "text",
          BankData.branch,
          handleBankChange,
          "Enter Branch",
          12,
          null,
          errors.branch
        )}
        {InputField(
          "Bank code",
          "ifsc_swift_code",
          "text",
          BankData.ifsc_swift_code,
          handleBankChange,
          "Enter Bank Code",
          12,
          null,
          errors.ifsc_swift_code
        )}
      </div>
    </>
  );

  return (
    <div className="page-wrappers">
      <div className="page-content">
        <NaviGate />
        <div className="mb-0 d-flex justify-content-between align-items-center">
          <h6 className="mb-0 text-uppercase" style={{ fontFamily: "poppins" }}>Suppliers List</h6>
          {!readonly && <button
            type="button"
            onClick={() => {
              setCardShow(1);
              setErrors({});
            }}
            className="btn btn-primary mb-0"
            style={{ fontFamily: "poppins", borderRadius: "6px" }}
          >
            Add Supplier
          </button>}
        </div>
        <hr className="mt-1" />

        {cardShow == 1 && (
          <>
            <div className="modal-backdrop fade show"></div>
            <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ fontFamily: "poppins" }}>
              <div className="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
                <div className="modal-content shadow border-0" style={{ borderRadius: "12px" }}>
                  <div className="modal-header px-4 pt-3 pb-2 border-0">
                    <h5 className="modal-title fw-bold" style={{ fontSize: "20px", color: "#1e293b" }}>
                      {EditButton ? "Edit Supplier" : "Add Supplier"}
                    </h5>
                    <button
                      type="button"
                      className="btn-close"
                      onClick={() => {
                        setCardShow(0);
                        handleclear();
                      }}
                    ></button>
                  </div>
                  <form onSubmit={(e) => { e.preventDefault(); handleSubmit(e, EditButton ? 1 : 0); }}>
                    <div className="modal-body px-4 py-2">
                      <div className="row g-2">
                        {/* Left Column */}
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Suppliers <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="full_name"
                              value={formData.full_name}
                              onChange={handleChange}
                              placeholder="Enter Name"
                              className={`form-control py-2 ${errors.full_name ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.full_name && <div className="invalid-feedback">{errors.full_name}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Address
                            </label>
                            <input
                              type="text"
                              name="address1"
                              value={formData.address1}
                              onChange={handleChange}
                              placeholder="Enter Address"
                              className={`form-control py-2 ${errors.address1 ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.address1 && <div className="invalid-feedback">{errors.address1}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Email
                            </label>
                            <input
                              type="text"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Enter Email"
                              className={`form-control py-2 ${errors.email ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Remarks
                            </label>
                            <textarea
                              name="remarks"
                              value={formData.remarks}
                              onChange={handleChange}
                              placeholder="Enter your remark"
                              className="form-control py-2"
                              rows={4}
                              style={{ borderRadius: "6px", fontSize: "14px", resize: "none" }}
                            />
                          </div>
                        </div>

                        {/* Right Column */}
                        <div className="col-md-6">
                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Phone <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              name="phone"
                              value={formData.phone}
                              onChange={handleChange}
                              placeholder="Enter Phone Number"
                              className={`form-control py-2 ${errors.phone ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              GST No
                            </label>
                            <input
                              type="text"
                              name="VAT_no"
                              value={formData.VAT_no}
                              onChange={handleChange}
                              placeholder="Enter GST"
                              className={`form-control py-2 ${errors.VAT_no ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.VAT_no && <div className="invalid-feedback">{errors.VAT_no}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Opening Balance (INR)
                            </label>
                            <input
                              type="number"
                              name="opening_balance"
                              min="0"
                              value={formData.opening_balance}
                              onChange={handleChange}
                              onKeyDown={(e) => ["-", "e", "E"].includes(e.key) && e.preventDefault()}
                              onWheel={(e) => e.target.blur()}
                              placeholder="Enter Opening Balance"
                              className={`form-control py-2 ${errors.opening_balance ? 'is-invalid' : ''}`}
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                            {errors.opening_balance && <div className="invalid-feedback">{errors.opening_balance}</div>}
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Account Name
                            </label>
                            <input
                              type="text"
                              name="account_name"
                              value={BankData.account_name}
                              onChange={handleBankChange}
                              placeholder="Enter Account Name"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Account no
                            </label>
                            <input
                              type="text"
                              name="account_no"
                              value={BankData.account_no}
                              onChange={handleBankChange}
                              placeholder="Enter Account No"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Bank
                            </label>
                            <input
                              type="text"
                              name="bank"
                              value={BankData.bank}
                              onChange={handleBankChange}
                              placeholder="Enter Bank"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Branch
                            </label>
                            <input
                              type="text"
                              name="branch"
                              value={BankData.branch}
                              onChange={handleBankChange}
                              placeholder="Enter Branch"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>

                          <div className="mb-2">
                            <label className="form-label fw-semibold text-secondary mb-1" style={{ fontSize: "14px" }}>
                              Bank code
                            </label>
                            <input
                              type="text"
                              name="ifsc_swift_code"
                              value={BankData.ifsc_swift_code}
                              onChange={handleBankChange}
                              placeholder="Enter Bank Code"
                              className="form-control py-2"
                              style={{ borderRadius: "6px", fontSize: "14px" }}
                            />
                          </div>
                        </div>
                      </div>
                      <div className="text-end mt-4">
                        <button
                          type="button"
                          className="btn btn-secondary px-4 py-2 me-2"
                          style={{ borderRadius: "6px", fontSize: "14px" }}
                          onClick={() => {
                            setCardShow(0);
                            handleclear();
                          }}
                        >
                          Cancel
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary px-4 py-2"
                          style={{ borderRadius: "6px", fontSize: "14px" }}
                        >
                          {EditButton ? "Update" : "Save"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </>
        )}

        {cardShow == 0 && (
          <div className="card">
            <div className="card-body">
              <div className="col-12 col-md-6 col-lg-4 mb-3 mb-md-2">
                <div
                  className="d-flex position-relative"
                  style={{ width: "100%" }}
                >
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search..."
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <img
                    src="/assets/images/icons/search.png"
                    alt="Search Icon"
                    style={{
                      position: "absolute",
                      right: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      height: "18px",
                      pointerEvents: "none",
                    }}
                  />
                </div>
              </div>
              <div className="table-responsive">
                <table
                  id="example"
                  className="table table-sm table-striped table-bordered p-2"
                  style={{ width: "100%", fontFamily: "poppins" }}
                >
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Address</th>
                      <th>Email</th>
                      <th>Phone</th>
                      {!readonly && <th>Actions</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {suppliers.map((supplier, index) => (
                      <tr key={supplier.supplier_id}>
                        <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                        <td>{supplier.full_name}</td>
                        <td>{supplier.address1}</td>
                        <td>{supplier.email || 'N/A'}</td>
                        <td>{supplier.phone}</td>
                        {!readonly && <td>
                          {supplier.status == null || supplier.status == 1 ?
                            (
                              <>
                                <img
                                  src="/assets/images/icons/edit.png"
                                  onClick={() => openModal(supplier)}
                                  height={"16px"}
                                />
                                <img
                                  src="/assets/images/icons/delete.png"
                                  className="mx-1"
                                  onClick={() =>
                                    handledeletemodel(supplier.supplier_id)
                                  }
                                  height={"16px"}
                                />
                              </>
                            ) : (
                              <>
                                <button className="btn btn-secondary py-1 rounded-1" style={{ fontSize: '13px' }} onClick={() => handleUndoDelete(supplier.supplier_id)}>Inactive</button>
                              </>
                            )}
                        </td>}
                      </tr>
                    ))}
                  </tbody>
                </table>
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                  entriesPerPage={entriesPerPage}
                  onEntriesPerPageChange={(val) => {
                    setEntriesPerPage(val);
                    setCurrentPage(1);
                    fetchSuppliers(1, "", val);
                  }}
                />
              </div>
            </div>
          </div>
        )}
      </div>
      {deletemodel && (
        <Deletemodel
          setShowModal={showDeletemodel}
          handleDelete={handleDelete}
        />
      )}

      {/* {showModal && (
        <SupplierForm
          selectedSupplier={selectedSupplier}
          onClose={() => setShowModal(false)}
          fetchSuppliers={fetchSuppliers}
        />
      )} */}
    </div>
  );
};

export default Supplier_list;
